import { motion } from "framer-motion";
import { Sunrise, Sun, Clock } from "lucide-react";
import { classes, periods } from "@/data/content";

const periodIcons = { Sunrise, Sun, Clock };
const classColors = ["#FF9ECE", "#4ECDC4", "#FF9F1C"];
const periodColors = { "brand-yellow": "#FFE66D", "brand-orange": "#FF9F1C", "brand-sky": "#45B7D1" };

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] } }),
};

export default function Classes() {
  return (
    <section id="turmas" className="relative py-24 md:py-32 bg-cream">
      <div className="mx-auto max-w-7xl px-5">
        <motion.div variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }} className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block rounded-full bg-brand-sky/15 text-brand-sky px-4 py-1.5 font-700 text-sm mb-4">
            Turmas e idades
          </span>
          <h2 className="font-display font-700 text-ink text-4xl md:text-5xl leading-tight">
            De 4 meses até o ingresso no 1º ano.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {classes.map((c, i) => (
            <motion.div
              key={c.name}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-40px" }}
              className="group relative rounded-[2rem] bg-white p-8 shadow-[0_8px_30px_rgb(30,58,95,0.05)] hover:shadow-[0_20px_50px_rgb(30,58,95,0.12)] hover:-translate-y-2 transition-all duration-300 overflow-hidden"
              data-testid={`class-${i}`}
            >
              <div className="absolute top-0 left-0 right-0 h-2" style={{ backgroundColor: classColors[i] }} />
              <span className="font-display font-700 text-6xl" style={{ color: `${classColors[i]}55` }}>
                0{i + 1}
              </span>
              <h3 className="font-display font-600 text-ink text-2xl mt-3">{c.name}</h3>
              <p className="font-body font-700 text-sm mt-1" style={{ color: classColors[i] }}>{c.age}</p>
              <p className="font-body text-ink-soft leading-relaxed mt-4">{c.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* Periods */}
        <motion.div variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }} className="rounded-[2rem] bg-ink p-8 md:p-12">
          <p className="font-display font-600 text-white/70 text-center mb-8 text-lg">Períodos disponíveis</p>
          <div className="grid sm:grid-cols-3 gap-5">
            {periods.map((p) => {
              const Icon = periodIcons[p.icon];
              const col = periodColors[p.color];
              return (
                <div key={p.name} className="rounded-2xl bg-white/10 backdrop-blur-sm p-6 flex items-center gap-4 hover:bg-white/15 transition-colors duration-300" data-testid={`period-${p.name}`}>
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl" style={{ backgroundColor: `${col}30` }}>
                    <Icon className="h-6 w-6" strokeWidth={2.5} style={{ color: col }} />
                  </span>
                  <span className="font-display font-600 text-white text-xl">{p.name}</span>
                </div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
